import React from 'react';

import {Button, Icon, Text} from '@albert-io/atomic';

import OnboardingPageLayout from '../OnboardingPageLayout';

export type ConsentOption = 'enroll-code' | 'class-invite' | 'parental-consent';

interface ConsentOptionStepProps {
  onSelectOption: (option: ConsentOption) => void;
}

export default function ConsentOptionStep({onSelectOption}: ConsentOptionStepProps) {
  return (
    <OnboardingPageLayout>
      <Text className='text-xxl font-black' data-testid='consent-option-step__heading'>
        Select an option
      </Text>

      <div className='flex flex-col gap-x1-half'>
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('enroll-code')}
          data-testid='consent-option-step__enroll-code'
        >
          <Text color='inherit'>Enter a class code</Text>
          <Icon icon='arrow-right' />
        </Button>
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('class-invite')}
          data-testid='consent-option-step__class-invite'
        >
          <Text color='inherit'>Accept class invitations</Text>
          <Icon icon='arrow-right' />
        </Button>
        <Button
          color='primary'
          variant='outlined'
          size='l'
          roundness='pill'
          className='w-full justify-between'
          onClick={() => onSelectOption('parental-consent')}
          data-testid='consent-option-step__parental-consent'
        >
          <Text color='inherit'>Request parental permission</Text>
          <Icon icon='arrow-right' />
        </Button>
      </div>
    </OnboardingPageLayout>
  );
}
